import React, { useCallback } from 'react'
import Button, { EButtonType } from '@/components/Button/Button'
import GoogleGrayscale from '@/assets/images/GoogleGrayscale.png'
import VARIABLES from '@/styles/config/_variables.module.scss'
import { useWindowSize } from '@react-hook/window-size'
import { Box } from '@mui/material'
import styles from './SignUp.module.scss'
import cx from 'classnames'
import { useGoogleOAuth } from '@/hooks/useGoogleOAuth'
import type { PlanId } from '@/hooks/useGoogleOAuth'

type Props = {
  ctaText?: string
  column?: boolean
  autoFocus?: boolean
  btnType?: EButtonType
  content?: string
  showGoogleIcon?: boolean
  width?: string
  selectedPlan?: PlanId
}

const SignUp = ({
  ctaText = 'Sign up with Google',
  column,
  btnType,
  showGoogleIcon = false,
  width,
  selectedPlan,
}: Props) => {
  const [widthW] = useWindowSize()
  const { redirectToGoogleOAuth } = useGoogleOAuth(selectedPlan)

  let buttonWidth = width ? width : '30rem'
  if (column) {
    buttonWidth = '100%'
  } else if (widthW <= parseInt(VARIABLES.mobile)) {
    buttonWidth = 'auto'
  }

  const handleClick = useCallback(() => {
    redirectToGoogleOAuth()
  }, [redirectToGoogleOAuth])

  return (
    <Box className={cx(styles.container, { [styles.column]: column })}>
      <Button
        className={styles.button}
        styleInline={{ flex: '0 0 1', width: buttonWidth }}
        onClick={handleClick}
        type={btnType}
      >
        {showGoogleIcon && <img src={GoogleGrayscale.src} className={styles.google} />}
        {ctaText}
      </Button>
    </Box>
  )
}

export default SignUp
